import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, Mail, TrendingUp } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const AdminLogin = () => {
  const { login, isAuthed } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (isAuthed) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError("Credenziali non valide. Riprova.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-sq-light flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <span className="font-serif-display text-3xl text-sq-navy">
            Società <span className="text-sq-orange">Quotate</span>
          </span>
          <p className="text-sm text-gray-500 mt-1">Pannello di amministrazione</p>
        </div>
        <form onSubmit={submit} className="bg-white border border-sq rounded-md shadow-sm p-8">
          <h1 className="font-serif-display text-2xl text-sq-navy mb-6">Accedi</h1>

          {error && (
            <div className="mb-4 text-sm text-red-600 bg-red-50 border border-red-200 rounded-sm px-3 py-2">
              {error}
            </div>
          )}

          <label className="block text-sm font-medium text-sq-navy mb-1">Email</label>
          <div className="flex items-center border border-sq rounded-sm mb-4 px-3">
            <Mail size={16} className="text-gray-400" />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="flex-1 px-2 py-2.5 text-sm outline-none"
              placeholder="admin@societaquotate.it"
            />
          </div>

          <label className="block text-sm font-medium text-sq-navy mb-1">Password</label>
          <div className="flex items-center border border-sq rounded-sm mb-6 px-3">
            <Lock size={16} className="text-gray-400" />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="flex-1 px-2 py-2.5 text-sm outline-none"
              placeholder="••••••••"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-sq-orange hover:bg-sq-orange-dark transition-colors text-white font-medium py-2.5 rounded-sm disabled:opacity-60"
          >
            {loading ? "Accesso in corso..." : "Entra nel pannello"}
          </button>
        </form>
        <p className="text-center text-xs text-gray-400 mt-6 flex items-center justify-center gap-1">
          <TrendingUp size={12} /> societaquotate.it — area riservata
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
